import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import images from '../../DisconnectPhotos/images';
import {connect} from 'react-redux';
import {Row} from 'reactstrap';
import {isBrowser, isMobile} from 'react-device-detect';

function DisconnectContent(props) {
  function renderUpperText() {
    if (props.serviceToDisconnect.serviceType == 'Cellular') {
      return props.serviceToDisconnect.HasBanlvlPpUnlimited ? (
        <div className='paragraph-txt'>
          מנוי זה משויך לחבילה שבה המחיר תלוי בכמות המנויים. ניתוק המנוי עשוי להשפיע על המחיר של המנויים הנוספים בחבילה
        </div>
      ) : (
        <div className='paragraph-txt'>החיוב בחשבונית הקרובה יהיה הסכום היחסי עד למועד הניתוק</div>
      );
    } else if (props.serviceToDisconnect.serviceType == 'TV') {
      return (
        <div className='paragraph-txt'>
          הניתוק יהיה מיידי ולאחריו שירותי {window.Config.brand_Name_HE} TV יחסמו
          <br />
          יש להחזיר את הציוד תוך 30 ימי עסקים
        </div>
      );
    } else {
      return (
        <div className='paragraph-txt'>
          הניתוק יהיה מיידי ולאחריו לא יהיה לך אינטרנט.
          <br /> יש להחזיר את הציוד תוך 30 ימי עסקים
        </div>
      );
    }
  }

  function renderBottomText() {
    if (props.serviceToDisconnect.serviceType == 'Cellular') {
      return <span className='txt'>לאחר ביצוע הניתוק, לא ניתן יהיה לנייד את המספר</span>;
    } else if (props.serviceToDisconnect.serviceType == 'TV') {
      return <span className='txt'>אם תואם לך טכנאי, ההגעה שלו תבוטל</span>;
    } else {
      return <span className='txt'>אם תואם לך טכנאי, ההגעה שלו תבוטל</span>;
    }
  }

  return (
    <>
      <Row className='main-header-row'>
        {isBrowser ? (
          <h3 style={{fontSize: '2.313rem'}} className='main-header'>
            חשוב שתדע
          </h3>
        ) : (
          <h3 style={{fontSize: '1.875rem'}} className='main-header'>
            חשוב שתדע
          </h3>
        )}
      </Row>
      <Row className='paragraph-txt-row'>{renderUpperText()}</Row>
      <Row>
        {isMobile ? (
          <Image style={{marginTop: '20px'}} src={images.bodyPicPurpleSmall} />
        ) : (
          <Image style={{marginTop: '20px'}} src={images.bodyPicPurpleMid} />
        )}
      </Row>
      <Row className='info-row'>
        <div className='info'>
          <Image className='img' src={images.infoIconPurple} alt='warning' />
          {renderBottomText()}
        </div>
      </Row>
    </>
  );
}

const mapStateToProps = (state) => ({
  stepInProcess: state.disconnectServicesBlock.stepInProcess,
  stepParams: state.disconnectServicesBlock.stepParams,
  serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectContent);
